<template>
  <div id="app">
    <router-view/>
    <load-comp/>
  </div>
</template>

<script>

export default {
  componets: {
  },
  methods: {
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Rubik');
@import '../node_modules/animate.css/animate.min.css';
@import './assets/tooltip.css';

body{
  margin: 0;
}
#app {
  font-family: 'Rubik', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100vh;
}
.bg_green{
  background-color: green;
}
.bg_grey{
  background-color: grey;
}

.error_input {
}
.p_err_min {
  font-size: 14px;
  margin: 1px auto 20px auto;
  color: #cc0000;
}
.p_err_main {
  font-size: 14px;
  color: #cc0000;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .4s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}

//синяя рамка
* {
  outline: 0 !important;
}
button::-moz-focus-inner {
  border: 0;
}
input::-moz-focus-inner {
  border: 0;
}
select:hover {
  cursor: pointer;
}

*:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.main_view {
  width: 100%;
  height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: 1fr;
  margin: 0;
}
.view_grid {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: auto 1fr;
  margin: 0;
}

.label_title {
  object-fit: contain;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #202020;
  float: left;
  margin: 0 0 8px 0;
}
.p_title {
  object-fit: contain;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #202020;
  margin: 0 0 8px 0;
}
.check_title {
  object-fit: contain;
  font-size: 18px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #202020;
  margin: 0 0 8px 0;
}

.label_nodata {
  font-size: 20px;
  color: #ff8200;
}

.input_orange{
  width: calc(100% - 24px);
  height: 53px;
  object-fit: contain;
  border-radius: 9px;
  border: solid 2px #ff8200;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.input_grey {
  margin: 0;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 10px;
  color: #202020;
  width: calc(100% - 22px);
  height: 32px;
}

.textarea_grey {
  margin: 0;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 10px;
  color: #202020;
  width: calc(100% - 22px);
}

.textarea_grey_1 {
  margin: 0;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 10px;
  color: #202020;
  width: calc(100% - 22px);
  height: 50px;
}

.select_grey {
  margin: 0;
  object-fit: contain;
  border-radius: 4px;
  border: solid 1px #bababa;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding-left: 10px;
  padding-right: 10px;
  color: #202020;
  width: 100%;
  height: 36px;
}

.div_nodata {
  width: 350px;
  margin: 32px auto 32px auto;
}

.btn_white_min {
  margin: 0;
  object-fit: contain;
  border-radius: 9px;
  background-color: #ffffff;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  padding: auto;
  color: #ff8200;
  width: 100%;
  height: 28px;
}

// div.multiselect__content-wrapper{
//   // border: red!important;
//   z-index: 5000!important;
// }
// .div_nodata {
//   display: grid;
//   grid-template-columns: 1fr;
//   grid-template-rows: 1fr;
//   grid-gap: 32px;
// }

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
  .view_grid {
    display: block;
    position: relative;
  }
  .view_grid .navbar {
    z-index: 1000;
    position: absolute;
  }
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
  .div_nodata{
    width: calc(100% - 32px);
  }
}
@media screen and (max-width: 320px){
}
</style>
